/* eslint-disable react/button-has-type */
import React from 'react'
import PropTypes from 'prop-types'

import { values, isFunction, isString } from 'lodash'
import classes from 'classnames'

import { ui, routing } from '../redux'

import Icon from '../components/Icon'

const TYPES = ['button', 'submit']

const ICON_SIZE = {
    [ui.SIZE.default] : 18,
    [ui.SIZE.xSmall]  : 10,
    [ui.SIZE.small]   : 14,
    [ui.SIZE.large]   : 20,
    [ui.SIZE.xLarge]  : 28
}

const Button = (props) => {
    const {
        intent, label, icon, size, isBlock, isRounded, isDropdown, isSpaced,
        children, className, onClick, link, type,
        ...otherProps
    } = props
    const clickHandler = isFunction(onClick) ? onClick : isString(link) && (() => routing.push(link))

    return (
        <button
            type={ type }
            onClick={ isFunction(clickHandler)
                ? (event) => {
                    event.stopPropagation()
                    clickHandler(event)
                }
                : null
            }
            className={ classes(
                'btn',
                `btn-${size}`,
                `btn-${intent}`,
                isSpaced ? 'btn-space' : null,
                isBlock ? 'btn-block' : null,
                isRounded ? 'btn-rounded' : null,
                isDropdown ? 'dropdown-toggle' : null,
                className
            ) }
            { ...otherProps }
        >
            { children }
            { React.isValidElement(icon) && icon }
            { isString(icon) && <Icon name={ icon } size={ ICON_SIZE[size] } /> }
            { icon && label && <span style={ { marginRight: 3 } } /> }
            { label }
            { isDropdown && (
                <Icon
                    className="dropdown-trigger"
                    name="md/keyboard-arrow-down"
                    size={ ICON_SIZE[size] }
                />
            ) }
        </button>
    )
}

Button.propTypes = {
    label      : PropTypes.string,
    icon       : PropTypes.node,
    intent     : PropTypes.oneOf(values(ui.INTENT)),
    size       : PropTypes.oneOf(values(ui.SIZE)),
    onClick    : PropTypes.func,
    link       : PropTypes.string,
    type       : PropTypes.oneOf(TYPES),
    isRounded  : PropTypes.bool,
    isBlock    : PropTypes.bool,
    isSpaced   : PropTypes.bool,
    isDropdown : PropTypes.bool
}

Button.defaultProps = {
    type       : 'button',
    intent     : ui.INTENT.default,
    size       : ui.SIZE.default,
    isBlock    : false,
    isRounded  : false,
    isSpaced   : false,
    isDropdown : false,
    onClick    : null,
    label      : null,
    link       : null
}

export default Button
